import getConfig from 'next/config';

const {
  publicRuntimeConfig: {
    GF_DOTCOM_ECOMM_CORE_ENDPOINT,
    GF_DOTCOM_ENDPOINT,
    GF_DOTCOM_USE_DEV_PROXY,
  },
} = getConfig();

const endpoint = GF_DOTCOM_USE_DEV_PROXY === 'true'
  ? GF_DOTCOM_ENDPOINT
  : GF_DOTCOM_ECOMM_CORE_ENDPOINT || '';

/**
 * Helper to access ecomm-core apis.
 * In local development, ecomm-core lives on a different domain/port.
 * In deployed environments, ecomm-core likely lives on the same domain.
 * Includes credentials in call for auth. Can override with options object.
 * @param {String} route Ecomm Core API route. Should have leading slash.
 * @param {Object} options Options to pass to fetch. See fetch spec for
 *                         more details. https://github.com/github/fetch
 */
export default function(route, options = {}) {
  return fetch(`${endpoint}${route}`, {
    credentials: 'include',
    ...options,
  });
}
